import React from "react";
import css from './center.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";

const Index = ({containerClassName, children}) => {
    return (
        <div id='footer' className={classNames(css.root)}>
            <div className={containerClassName}>
                {children}
            </div>
        </div>
    )
}

export default observer(Index)